import React from "react";
import type { ComponentType, JSX, SVGProps } from "react";
import { GeographicalRegionCode } from "../../../../services/graphql/shared/Base";
import {
  CanadaFlagIcon,
  EuFlagIcon,
  GlobeIcon,
  UsFlagIcon,
} from "./LocationIcons";

const REGION_ICONS: Record<
  GeographicalRegionCode,
  ComponentType<SVGProps<SVGSVGElement>>
> = {
  CA: CanadaFlagIcon,
  US: UsFlagIcon,
  EU: EuFlagIcon,
  INTL: GlobeIcon,
};

export const CurrentRegionIcon = ({
  code,
  className,
}: {
  readonly code: GeographicalRegionCode;
  readonly className?: string;
}): JSX.Element => {
  const Icon = REGION_ICONS[code];
  return <Icon className={className} aria-hidden />;
};
